export default __webpack_public_path__ + "images/KX.aa1c33a.png";